import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { EmeraldModalModule } from '@emerald-angular/modal';
import { EmeraldDropdownModule } from '@emerald-angular/dropdown';
import { EmeraldButtonModule } from '@emerald-angular/button';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
} from '@angular/forms';
import { BreakdownRow } from '@app/shared/interfaces/candidates.model';

@Component({
  selector: 'app-interview-status-widget-filter',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    EmeraldModalModule,
    EmeraldDropdownModule,
    EmeraldButtonModule,
  ],
  templateUrl: './interview-status-widget-filter.component.html',
  styleUrl: './interview-status-widget-filter.component.scss',
})
export class InterviewStatusWidgetFilterComponent implements OnInit, OnChanges {
  @Input() breakdown: BreakdownRow[] = [];
  @Output() applyFilter = new EventEmitter<{ statusCounts: Record<string, number> | null; buttonClick: string }>();

  filterForm!: FormGroup;
  openForm: boolean = true;
  monthYearOptions = [];
  lobOptions: { label: string; value: string }[] = [];
  projectNameOptions: { label: string; value: string }[] = [];
  vendorOptions: { label: string; value: string }[] = [];
  jobTitleOptions: { label: string; value: string }[] = [];

  constructor(public fb: FormBuilder) {}

  ngOnInit(): void {
    this.initializeForm();
  }

  initializeForm(): void {
    this.filterForm = this.fb.group({
      lob: [null],
      projectName: [null],
      vendor: [null],
      jobTitle: [null],
    });
  }

  setFilterOptions(): void {
    if (!Array.isArray(this.breakdown) || !this.breakdown.length) return;
    const unique = (key: keyof BreakdownRow) =>
      Array.from(new Set(this.breakdown.map((r) => r[key] as string).filter(Boolean)))
        .map((v) => ({ label: v, value: v }));

    this.lobOptions = unique('lob');
    this.projectNameOptions = unique('projectName');
    this.vendorOptions = unique('vendorName');
    this.jobTitleOptions = unique('jobTitle');
  }

  ngOnChanges(): void {
    this.setFilterOptions();
  }

  reset() {
    this.filterForm.reset();
    this.openForm = false;
    setTimeout(() => (this.openForm = true), 10);
    this.applyFilter.emit({ statusCounts: null, buttonClick: 'reset' });
  }

  apply() {
    const { lob, projectName, vendor, jobTitle } = this.filterForm.value;
    const filtered = this.breakdown.filter((row) =>
      (!lob || row.lob === lob.value) &&
      (!projectName || row.projectName === projectName.value) &&
      (!vendor || row.vendorName === vendor.value) &&
      (!jobTitle || row.jobTitle === jobTitle.value)
    );
    const merged: Record<string, number> = {};
    filtered.forEach((row) => {
      Object.entries(row.statusCounts).forEach(([status, count]) => {
        merged[status] = (merged[status] ?? 0) + count;
      });
    });
    this.applyFilter.emit({ statusCounts: merged, buttonClick: 'apply' });
  }
}
